import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import Helmet from 'react-helmet'

import { RafLandingPage } from '@features/raf-landing-page'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { onScrollHandler } from 'routes/Home/Hero/heroUtils'

import { seo } from './seoConfig'

export const RafPage = () => (
  <Box>
    <Helmet title={seo.title} meta={seo.meta} />
    <RafLandingPage
      onScrollHandler={onScrollHandler}
      useIsOptimizelyFeatureEnabled={useIsOptimizelyFeatureEnabled}
    />
  </Box>
)
